export const applyEmail = "hello@the-groundwork.com";

// Single on/off switch for the whole Careers pause. Flip to false to reopen
// hiring and restore the role listings, role pages and apply actions exactly
// as they were. No careers content is deleted while paused.
export const HIRING_PAUSED = true;

export const careers = [
  {
    slug: "brand-strategist",
    title: "Brand Strategist",
    type: "Contract",
    location: "Project-based",
    blurb:
      "Turn founder obsession into positioning, narrative and a reason to be chosen.",
    accent: "#F2C14E",
    fg: "#1C1C19",
    summary:
      "We're looking for a strategist who can sit with founders, cut through the noise, and land the one idea a whole brand can be built on. You'll own positioning, narrative and the strategic foundations that everything else gets built on top of.",
    about: [
      "As a Brand Strategist at GroundWork, you'll lead the thinking behind our engagements, working directly with founders across sectors and geographies to define who a brand is for, what it stands for, and the single sentence it wants to be known for.",
      "This is a senior, hands-on role. You'll run discovery, frame the strategy, and stay close as it turns into identity, creative and growth. We work brand-first, so your work sets the direction for everyone else in the room.",
    ],
    responsibilities: [
      "Lead founder interviews, customer research and competitor teardowns",
      "Craft positioning, messaging hierarchies and brand narratives",
      "Write the strategy documents the whole team rallies behind",
      "Partner with creative and growth leads to keep work on-strategy",
      "Present and defend thinking directly to founders and boards",
    ],
    requirements: [
      "5+ years in brand strategy at an agency, studio or in-house",
      "A portfolio of positioning work that shipped and moved a business",
      "Sharp writing and the ability to make complex ideas simple",
      "Comfort leading rooms of senior stakeholders and founders",
      "Curiosity across categories: consumer, B2B, tech and beyond",
    ],
  },
  {
    slug: "creative-director",
    title: "Creative Director",
    type: "Contract",
    location: "Project-based",
    blurb:
      "Own identity systems and art direction that make brands unmistakable.",
    accent: "#E26D5C",
    fg: "#F7F5F0",
    summary:
      "We want a Creative Director who treats the work as the brand. You'll set the visual and verbal direction for our engagements and hold the bar high, from identity systems to campaigns that people actually remember.",
    about: [
      "As Creative Director, you'll translate strategy into identity, art direction and craft. You'll lead designers, writers and producers, and be as comfortable in a founder pitch as you are in a review with the studio.",
      "You care about detail obsessively but never lose the big idea. You'll shape how our brands look, sound and feel across every surface: packaging, film, retail and web.",
    ],
    responsibilities: [
      "Set creative direction for brand identity systems and campaigns",
      "Lead and mentor designers, writers and producers",
      "Translate positioning into distinctive, ownable visual worlds",
      "Oversee production quality end to end, on time and on budget",
      "Present creative directly to founders and win their trust",
    ],
    requirements: [
      "7+ years in design/creative with 2+ leading teams",
      "A portfolio of identity and campaign work with genuine craft",
      "Fluency across brand, digital, motion and packaging",
      "Strong point of view and the taste to know what to kill",
      "Experience shipping work for brands across sectors and markets",
    ],
  },
  {
    slug: "growth-lead",
    title: "Growth Lead",
    type: "Contract",
    location: "Project-based",
    blurb:
      "Build the engine that compounds: retention, performance and lifecycle.",
    accent: "#729B79",
    fg: "#F7F5F0",
    summary:
      "We're hiring a Growth Lead who's operated, not just advised. You'll build and run the growth engine for our engagements, measured at the unit level, honest about what works, and always brand-first.",
    about: [
      "As Growth Lead, you'll embed into portfolio companies to audit, plan and operate growth across acquisition, retention and channel mix. You'll hand the playbook to their team at the end; this is about building capability, not dependency.",
      "You're equally at home in a spreadsheet and a strategy conversation, and you know that the best growth is built on a brand worth choosing in the first place.",
    ],
    responsibilities: [
      "Audit data, agencies and tech stacks to find real leverage",
      "Build channel-by-channel growth plans with honest budgets",
      "Run paid acquisition, retention and lifecycle programs",
      "Instrument measurement at the unit-economics level",
      "Coach in-house teams to own the engine after hand-off",
    ],
    requirements: [
      "5+ years in growth/performance with owned P&L impact",
      "Hands-on across paid, CRM, lifecycle and analytics",
      "Fluency with the modern growth and DTC tech stack",
      "A bias for experiments and for telling the truth about results",
      "Experience across consumer and B2B growth motions",
    ],
  },
];

export const getCareerBySlug = (slug) => careers.find((c) => c.slug === slug);
